import { Input, Select } from 'antd';
import styled from 'styled-components';

export const InputStyled = styled(Input)`
  background-color: #ffffff;
  border-radius: 2px;
  color: #828282;
  border: 1px solid #b2bbbf;
  min-width: 0;
  outline: none;
  &:focus {
    background: #ffffff;
    border: 1px solid #000000;
    color: #000000;
    &:hover {
      background: #ffffff;
      border: 1px solid #000000;
    }
  }
  &:hover {
    background: #ffffff;
    border: 1px solid #b2bbbf;
  }
`;

export const InputSelect = styled(Select)`
  background-color: #ffffff;
  border-radius: 2px;
  color: #828282;
  border: 1px solid #b2bbbf;
  min-width: 0;
  outline: none;
  max-width: ${({ tamanho }) => tamanho || ''};
  &:focus {
    background: #ffffff;
    border: 1px solid #000000;
    color: #000000;
    &:hover {
      background: #ffffff;
      border: 1px solid #000000;
    }
  }
  &:hover {
    background: #ffffff;
    border: 1px solid #b2bbbf;
  }
`;

export const DivSelect = styled.div`
  display: flex;
  align-items: center;
  width: ${({ tamanho }) => tamanho || '32%'};
`;

export const DivItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export const DivButtons = styled(DivItems)`
  display: flex;
  float: right;
  gap: 15px;
`;

export const ButtonCancelar = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 96px;
  height: 32px;
  background: #fff;
  color: #24a95d;
  border: 1px solid #24a95d;
  border-radius: 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
`;

export const ButtonSalvar = styled(ButtonCancelar)`
  border: none;
  color: #fff;
  background: #24a95d;
`;
